var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4743 14.6177L6.63134 9.14012L1.82046 14.6177H-0.214844L5.72836 7.85277L-0.214844 -0.617188H5.01068L8.63261 4.54537L13.1707 -0.617188H15.206L9.53862 5.83442L15.6998 14.6177H10.4743ZM12.7408 13.0734H11.3706L2.69941 0.927074H4.06985L7.54272 5.79057L8.14327 6.63452L12.7408 13.0734Z",
    fill: "#242E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.2ba5a3516087165a5d13780e6af65dd2.svg";
export { ForwardRef as ReactComponent };